export default "__VITE_ASSET__c6b1331e__";